import {Select, Text} from '../1elements'
import {useEffect, useState} from 'react'
import FormHelperText from '@mui/material/FormHelperText'

const ProvinceSelect = ({disabled, onChange, value, validation}) => {
    const [selectedOption, setSelectedOption] = useState(null)
    const options = ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador',
        'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan',
        'Yukon']

    const values = ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']

    const setValue = (value) => {
        onChange(values[options.indexOf(value)])
    }

    const valueToOptionConverter = (value) => {
        return options[values.indexOf(value)]
    }

    useEffect(()=>{
        setSelectedOption(valueToOptionConverter(value))
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [value])

    return(
        <div>
            <Text type={'fieldLabel'}>Province<span className={'requiredAsterisk'}>*</span></Text>
            <Select value={selectedOption} onChange={setValue} options={options} disabled={disabled} error={Boolean(validation)}/>
            <FormHelperText error={Boolean(validation)}>{validation}</FormHelperText>
        </div>

    )
}

export default ProvinceSelect
